export default [
  {
    path: '/metaplanet_board',
    name: 'BoardView',
    component: () =>
      import(/* webpackChunkName: "portal" */ '@/views/Portal/BoardView.vue'),
    meta: { title: 'Metaplanet Board', group: 'portal' },
  },
  {
    path: '/metaplanet_mintit',
    name: 'MintitView',
    component: () =>
      import(/* webpackChunkName: "portal" */ '@/views/Portal/MintitView.vue'),
    meta: { title: 'Metaplanet Mintit', group: 'portal' },
  },
]
